<template>
  <div class=" lesson-brief">
    <div class="dept-brief-1 container">
      <div class="brief">
        <el-row :gutter="24">
          <el-col :span="4" style="text-align:center">
            <el-avatar :size="120" :src="dept1.deptLogo | filterUrl">
              <img :src="require('@/assets/imgs/error_image.png')" />
            </el-avatar>
          </el-col>
          <el-col :span="16">
            <div class="dept-name" v-text="dept1.name"></div>
            <div class="dept-briefIntro">{{dept1.briefIntro | ellipsis}}</div>
          </el-col>
          <el-col :span="4" style="text-align:right">
            <el-button :style="focusFlag?'background-color: #909399;color:#fff' : 'background-color:#44A8F3;color:#fff'" @click="attenDept">{{focusFlag?'取消关注':'关注'}}</el-button>
            <el-row style="margin-top:32px;font-size:14px">
              <el-col :span="12">
                <span style="color:#999">浏览：</span><span style="color:#4682B4">{{dept1.numView}}</span>
              </el-col>
              <el-col :span="12">
                <span style="color:#999">关注：</span><span style="color:#4682B4">{{dept1.numAttention}}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-divider class="divider-48-24"></el-divider>
        <div class="lessons">
          <el-row>
            <el-col :span="5">
              <div class="all-course" style="padding:6px 0;margin:12px 0;text-align:center;font-size:36px;color:#4d9de7" v-text="deptBrief.allCourse"></div>
              <div style="text-align:center">所有课程</div>
            </el-col>
            <el-col :span="5">
              <div class="top-course" style="padding:6px 0;margin:12px 0;text-align:center;font-size:36px;color:#FFB40A" v-text="deptBrief.topCourse"></div>
              <div style="text-align:center">一流课程</div>
            </el-col>
            <el-col :span="5">
              <div class="public-course" style="padding:6px 0;margin:12px 0;text-align:center;font-size:36px;color:#E7844D" v-text="deptBrief.publicCourse"></div>
              <div style="text-align:center">公开课程</div>
            </el-col>
            <el-col :span="5">
              <div class="teacher-count" style="padding:6px 0;margin:12px 0;text-align:center;font-size:36px;color:#8750E6" v-text="deptBrief.numOfTeachers"></div>
              <div style="text-align:center">入驻名师</div>
            </el-col>
            <el-col :span="4">
              <div class="student-count" style="padding:6px 0;margin:12px 0;text-align:center;font-size:36px;color:#49BED8" v-text="deptBrief.numOfStudents"></div>
              <div style="text-align:center">机构学员</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="dept-brief-2 container">
      <div>
        <el-row>
          <el-col :span="23">
            <h4>推荐课程</h4>
          </el-col>
          <!-- <el-col :span="1">
            <el-link type="info" @click="changePath({ name: 'lessonMajor' })">更多 <icon name="more_gray" :w="8" :h="8" style="margin-bottom:2px"></icon>
            </el-link>
          </el-col> -->
        </el-row>
        <el-divider class="divider-6-24"></el-divider>
        <el-row :gutter="24">
          <el-col :span="6" v-for="item in deptRecommendList" :key="item.id" >
            <el-card :body-style="{padding:0}">
              <el-image style="width: 100%; height: 180px" :src="item.avatar | filterUrl" fit="cover" @click="handleRecommend(item)">
                <div class="image-placeholder" slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
                <div class="image-error" slot="error">
                  <div style="width: 100%; height: 100%;background:#E1EBF0;text-align:center;">
                    <el-image :src="require('@/assets/imgs/error_image.png')" style="width: 84px; height: 60px;margin-top:42px"></el-image>
                  </div>
                </div>
              </el-image>
              <div class="hot-class">
                <div class="class-title" v-text="item.lessonName"></div>
                <el-row>
                  <el-col :span="16" style="color:#666;font-size:14px">课堂老师 : <span>{{item.userName}}</span></el-col>
                  <el-col :span="8" style="text-align:right">
                    <i class="icon icon-user-organization"></i>{{ item.memberNum }}
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="dept-brief-3">
      <div class="cates container">
        <div class="major-item" v-for="item in tags" :key="item.id">
          <el-row>
            <el-col :span="1">
              <div class="major-title">{{ item.name }}：</div>
            </el-col>
            <el-col :span="23">
              <common-tags class="region-box" :list="item.list" :props="item.props" :value.sync="item.value" :show-more="item.showMore" :change="changeMajor" />
            </el-col>
          </el-row>
        </div>
        <div class="organ-type">
          <el-row>
            <el-col :span="1">
              <div class="organ-title">类型：</div>
            </el-col>
            <el-col :span="23">
              <radio-group-btn class="radio-group-tag" :data="group1" name="group1" default-value="0" :change="changeType" />
            </el-col>
          </el-row>
        </div>
        <div class="organ-type">
          <el-row>
            <el-col :span="1">
              <div class="organ-title">排序：</div>
            </el-col>
            <el-col :span="23">
              <radio-group-btn class="radio-group-tag" :data="group2" name="group2" default-value="ll.create_time desc" :change="changeOrder" />
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <is-empty :show="labList.length > 0" message="暂时没有数据~">
          <div class="lesson-items-container clear-both">
            <div class="lesson" v-for="item in labList" :key="item.lessonId" @click="handleClickLesson(item)">
              <el-card :body-style="{padding:0}">
                <a class="lesson-box">
                  <div class="sign-box" @click.stop="handleClickDetail(item)">
                    <span>查看详情</span>
                  </div>
                  <div class="lesson-img">
                    <el-image fit="cover" :src="item.avatar | filterUrl" style="width:100%;height:100%">
                      <div class="image-placeholder" slot="placeholder">
                        <i class="el-icon-loading"></i>
                      </div>
                      <div class="image-error" slot="error">
                        <div style="width: 100%; height: 100%;background:#E1EBF0;text-align:center;">
                          <el-image :src="require('@/assets/imgs/error_image.png')" style="width: 84px; height: 60px;margin-top:42px"></el-image>
                        </div>
                      </div>
                    </el-image>
                  </div>
                  <div class="lesson-body clear-both">
                    <div class="lesson-name" v-text="item.lessonName"></div>
                    <div class="lesson-desc" v-text="item.summary"></div>
                    <div class="lesson-footer">
                      <span>任课教师：{{ item.teacher }}</span>
                      <div class="lesson-footer-score">
                        <span v-if="item.credits">
                          <el-tag size="mini">{{
                                    `${item.credits}学分`
                                    }}</el-tag>
                        </span>
                        <span v-if="item.periods">
                          <el-tag size="mini">{{
                                    `${item.periods}课时`
                                    }}</el-tag>
                        </span>
                        <span class="lesson-per-num" style="padding:0">
                          <i class="icon icon-user-organization"></i>{{ item.memberNum }}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </el-card>
            </div>
          </div>
          <div class="lab-list-page">
            <el-pagination background prev-text="上一页" next-text="下一页" layout="prev, pager, next" :total="page.total" :current-page="page.currentPage" :page-size="page.pageSize" @current-change="handlePageChange">
            </el-pagination>
          </div>
        </is-empty>
      </div>
    </div>
    <div style="background:#F5F5F5;height:24px"></div>
    <div class="lesson-interchange">
      <div class="container">
        <commentComponet :setId="setId" />
      </div>
    </div>
    <div style="background:#F5F5F5;height:24px"></div>
    <el-dialog :title="this.title" center :visible.sync="flag" width="840px" class="lesson-exp-detail">
      <el-row :gutter="12">
        <el-col :span="12" v-for="(item, index) in expData" :key="item.uid" class="exp-item">
          <span v-text="
                        `${(labExpPage.page - 1) * labExpPage.limit + index + 1}、${
                            item.name
                        }`
                        "></span>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-pagination background layout="prev, pager, next" :current-page="labExpPage.page" :page-size="labExpPage.limit" :total="labExpPage.total" @current-change="handleLabExpPageChange">
        </el-pagination>
      </span>
    </el-dialog>

    <!-- 实验交流 -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getDept, getDeptBrief, attend, cancel } from '@/api/system/dept'
import { getDeptRecommend } from '@/api/system/deptRecommend'
import isEmpty from '../../../components/common/is-empty.vue'
import commonTags from '@/components/common/tags'
import radioGroupBtn from '@/components/common/radio-group-btn'
import { getLabExpsNoToken } from '@/api/lab/experiment'
import {open_blank} from "@/utils/router"
import commentComponet from '@/components/Comment-component'

import {
  getAllList,
  checkLesson,
  joinPublicLesson
  //joinPrivateLesson
} from '@/api/lab/lesson'
let dept2 = {
  briefIntro: '',
  deptLogo: '',
  deptRegion: '',
  name: '',
  numAttention: null,
  numView: null,
  attended: false
}
let brief = {

}


export default {
  components: {
    radioGroupBtn,
    commonTags,
    commentComponet,
    isEmpty
  },

  data() {
    return {
      tagForm: {
        tagName: '',
      },
      focusFlag: false,
      labExpPage: {
        lessonUid: '',
        total: 0,
        page: 1,
        limit: 6
      },
      setId: null,
      title: '',
      flag: false,
      open: false,
      expData: [],
      dept1: {
        ...dept2
      },
      deptBrief: {
        ...brief
      },
      deptRecommendList: [],
      group1: [
        { text: '全部', value: 'all' },
        { text: '公开课', value: '0' },
        // { text: '一流课程', value: '2' }
      ],
      group2: [
        { text: '综合', value: 'll.id desc' },
        { text: '最新', value: 'll.create_time desc' },
        // { text: '最热', value: 'num desc' }
      ],
      tags: [
        {
          id: 1,
          name: '专业',
          showMore: false,
          value: 0,
          props: {
            label: 'dictValue',
            value: 'dictKey'
          },
          list: [{ dictKey: 0, dictValue: '全部' }]
        }
      ],
      labList: [],
      page: {
        currentPage: 1, // 当前页
        pageSize: 12 // 每页条目数
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
    ...mapGetters("course", ["majorTreeList"]),
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 150) {
        return value.slice(0, 150) + "...";
      }
      return value;
    },
  },
  methods: {
    ...mapActions(['setLoginVisible']),
    ...mapActions("course", {
      getTags: "selectCourseMajorDict",
    }),
    attenDept() {
      if (!this.token) this.setLoginVisible(true)
      else {
        if (this.focusFlag) {
          this.$confirm('是否取消关注？', '确认取消', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            let { deptId } = this.$route.params
            cancel(deptId).then(() => {
              this.$message.warning('取消关注成功!')
              this.getDepts()
            })
          }).catch(() => {
            this.$message.warning('取消操作!')
          })
        } else {
          let { deptId } = this.$route.params
          attend(deptId).then(() => {
            this.$message.success('关注成功')
            this.getDepts()
          })
        }
      }
    },
    getDepts() {
      var id = this.userInfo.id
      if (!id) {
        id = 0
      }
      let { deptId } = this.$route.params
      this.dept1 = {}
      this.setId = Number(this.$route.params.deptId)
      getDept(deptId, id).then(res => {
        this.dept1 = res
        this.focusFlag = this.dept1.attended
      })
    },
    getDeptBriefById() {
      let { deptId } = this.$route.params
      this.deptBrief = {}
      getDeptBrief(deptId).then(res => {
        this.deptBrief = res
      })
    },
    getDeptRecommendList() {
      let { deptId } = this.$route.params
      this.deptRecommendList = []
      getDeptRecommend(deptId).then(res => {
        // 推荐课程最多只让展示4个
        if (res.length > 4) {
          this.deptRecommendList = res.slice(0, 4);
        } else {
          this.deptRecommendList = res
        }

      })
    },
    // 获取课堂实验列表
    async initExpList(uid) {
      const { labExpPage } = this
      const { limit = 6, lessonUid } = labExpPage
      let { page = 1 } = labExpPage
      let arr = []
      let total = 0
      if (!uid) uid = lessonUid
      if (lessonUid !== uid) {
        page = 1
        this.$set(this.labExpPage, 'page', 1)
      }
      await getLabExpsNoToken(page, limit, {
        lessonUid: uid,
        sidx: 'view_index, create_time DESC'
      }).then(({ totalCount, list }) => {
        total = totalCount
        arr = list
      })
      this.$set(this.labExpPage, 'total', total)
      this.$set(this.labExpPage, 'lessonUid', uid)
      this.expData = arr
      if (arr.length > 0) this.flag = true
    },
    handleLabExpPageChange(page) {
      this.$set(this.labExpPage, 'page', page)
      this.initExpList()
    },
    getLabList(params = {}) {
      let page = this.page.currentPage
      let limit = this.page.pageSize
      let obj = {
        ...params,
        ...this.searchForm
      }
      this.labList = []
      if (!obj.likeLessonName)
        delete obj.likeLessonName
      getAllList(page, limit, obj).then(data => {
        if (data) {
          this.page = {
            currentPage: data.currPage, // 当前页
            pageSize: data.pageSize, // 每页条目数
            total: data.totalCount
          }
          this.labList = data.list
        }
      })
    },
    handleRecommend(item) {
      const { uid, lessonName, publicFlag } = item
      if (publicFlag === 2) { // 申报课堂
        // 在新标签页中打开申报页面
        open_blank({
          name: "shenbaoV1",
          params: {
            key: item.keyUrl
          }
        })
        return
      }
      if (!this.token) this.setLoginVisible(true)
      else {
      //判断实验课堂的状态，是否可进入
      checkLesson(uid).then(res => {
        if (res == 3) {
          // 询问是否想要加入该课堂
          this.$confirm(`是否加入课堂"${lessonName}"`, '提 示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(() => {
              joinPublicLesson(uid)
                .then(() => {
                  this.$message.success('加入成功！')
                })
                .catch(err => {
                  window.console.error(err)
                })
            })
            .catch(() => { })
        } else this.$router.push(`/lesson/${uid}/type/exp`)
      })
      }
    },
    handleClickLesson(item) {
      const { uid, lessonName } = item
      if (!this.token) this.setLoginVisible(true)
      else {
        // 判断实验课堂的状态，是否可进入
        checkLesson(uid).then(res => {
          if (res == 3) {
            // 询问是否想要加入该课堂
            this.$confirm(`是否加入课堂"${lessonName}"`, '提 示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            })
              .then(() => {
                joinPublicLesson(uid)
                  .then(() => {
                    this.$message.success('加入成功！')
                  })
                  .catch(err => {
                    window.console.error(err)
                  })
              })
              .catch(() => { })
          } else this.$router.push(`/lesson/${uid}/type/exp`)
        })
      }
    },
    handleClickDetail(item) {

      this.title = item.lessonName
      this.initExpList(item.uid)
    },
    // 点击“加入私有课”按钮
    joinPLesson() {
      if (!this.token) {
        this.setLoginVisible(true)
      } else {
        this.open = true
        this.form = {}
      }
    },
    handleClickDept() {
      alert("点击进入该课程")
    },
    changeMajor(type) {
      var majorName;
      if (type == 1) {
        majorName = this.tags[0].list[1].dictValue
      } else if (type == 2) {
        majorName = this.tags[0].list[2].dictValue
      } else if (type == 3) {
        majorName = this.tags[0].list[3].dictValue
      }
      this.searchForm = {
        ...this.searchForm,
        majorName
      }
      this.getLabList()
    },
    changeType(type) {
      var publicFlag;
      if (type == 'all') {
        publicFlag = '';
      } else {
        publicFlag = type
      }
      this.searchForm = {
        ...this.searchForm,
        publicFlag
      }
      this.getLabList()

    },
    changeOrder(sidx) {
      this.searchForm = {
        ...this.searchForm,
        sidx
      }
      this.getLabList()
    },
    // currentPage 改变时会触发
    handlePageChange(page) {
      this.$set(this.page, 'currentPage', page)
      this.getLabList()
    },
    submitTag() {
      this.$refs['tagForm'].validate((valid) => {
        if (valid) {
          // do something
        }
      })
    },
    initCourseMajorTags() {
      this.tags[0].list = [
        {
          dictKey: 0,
          dictValue: '全部',
        },
        ...this.majorTreeList,
      ]
    }
  },
  watch: {   //检测邮箱有没有绑定,如果没绑定就给出提示
    'userInfo.id': {
      immediate: true,
      handler: function (val) {
        if (val != null) {
          this.getDepts()
        }
      }
    },
  },
  created() {
    if (this.majorTreeList.length < 1) {
      this.getTags().then(() => {
      }).catch(() => {
      }).finally(() => {
        this.initCourseMajorTags()
      })
    } else {
      this.initCourseMajorTags()
    }
    this.getDepts()
    this.getLabList()
    this.getDeptBriefById()
    this.getDeptRecommendList()
  }


}



</script>
<style lang="less" scoped>
@import "~@/assets/css/dept-brief.less";
</style>
<style lang="less" scoped>
.divider-6-24 {
  margin: 6px 0 24px 0;
  background-color: #dcdcdc;
}
.divider-48-24 {
  margin: 48px 0 24px 0;
}
.dept-brief-1 {
  margin-top: 24px;
  padding: 48px 54px;
  background: linear-gradient(180deg, #e5f5ff, #ffffff 100%);
}
.dept-brief-2 {
  padding: 48px 12px;
  .hot-class {
    padding: 12px 12px 24px 12px;
    .class-title {
      margin-bottom: 15px;
      color: #333;
      height: 36px;
    }
  }
}

.dept-brief-3 {
  background-color: #fff;
  padding: 48px 0;
  .organ-title {
    margin-top: 4px;
  }
  .organ-type {
    font-size: 14px;
    margin-bottom: 15px;
    .radio-group-tag {
      font-size: 14px !important;
    }
  }
}
.lesson-interchange {
  background: #fff;
  padding: 24px 0 84px 0;
}
</style>
